import { render, staticRenderFns } from "./medalCategory.vue?vue&type=template&id=1943d3ec&scoped=true"
import script from "./medalCategory.vue?vue&type=script&lang=js"
export * from "./medalCategory.vue?vue&type=script&lang=js"
import style0 from "./medalCategory.vue?vue&type=style&index=0&id=1943d3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1943d3ec",
  null
  
)

export default component.exports